import DataBinder from "./DataBinder.js"
export default class Toast {
    constructor(containerId, notificationItemClass) {
        this.containerId = containerId;
        this.notificationItemClass = notificationItemClass;
        this.dataBinder = new DataBinder();
    }
    show(content, duration) {
        //if string then create element
        if (typeof content == "string") {
            content = this.createNotificationFromString(content);
        }

        this.showNotification(content, duration);
    }
    createNotificationFromString(message) {

        let element = document.createElement("div");
        element.innerText = message;
        element.classList.add("notificationItem");
        return element;
    }
    showNotification(content, duration) {
        if (!duration) duration = 5;
        const containerId = this.containerId || "notifications";
        const notificationItemClass = this.notificationItemClass || "notification";

        let notifications = document.getElementById(containerId);
        if (!notifications) return;

        ////play sound
        //this.playSound("PointSound");

        //create notification container
        let notification = document.createElement("div");
        notification.classList.add(notificationItemClass);
        notification.style.animationDuration = duration + "s";
        notification.onclick = function () {
            this.style.display = "none";
        };
        notification.appendChild(content);

        //auto hide timer
        window.setTimeout(function () {
            notifications.removeChild(notification);
        }, duration * 1000);

        //add to list
        notifications.appendChild(notification);
    }
    showNewItemPopup(itemName) {
        let item = this.items.getItem(itemName);
        if (!item) return;
        let modelItem = {
            title: "New Item!",
            description: item.title,
            image: item.icon
        };
        let itemElement = this.dataBinder.create("itemNotification", modelItem);
        this.showNotification(itemElement);
    }
    showAchievementPopup(achievements) {
        ////play sound
        //this.playSound("AchivementSound");

        for (var i = 0; i < achievements.length; i++) {
            let achievement = achievements[i];
            let model = {
                title: achievement.title,
                description: achievement.description,
                image: achievement.image,
                points: achievement.points
            };
            let achievementElement = this.dataBinder.create("achievementNotification", model);
            this.showNotification(achievementElement);
            //check for item
            if (achievement.item) {
                this.showNewItemPopup(achievement.item)
            }

        }
        return;
    }

    get notificationAchievement() {
        return `    
    <template id="achievementNotification">
    <div class="achievement">
        <img data-src='images/Achievements/{image}' />
        <div class='points' data-inner-text="points"></div>
        <div class='title' data-inner-text="title"></div>
        <div class='description' data-inner-text="description"></div>
    </div>
</template>`;
    }

}